'use strict';

angular.module('shiftTraderApp')
    .controller('ViewDayOffModalCtrl', function($scope, AvailabilityRules, TimeService, SAErrorHandler, toastr,
                                           Session, $interval, DaysOffStore, DayOffLimitStore, DaysOffUserStatsService,
                                           WorkPeriods, params, dayOff, $uibModalInstance, DaysOffManagementModalService,
                                           UserPermissionsService, OverrideTokens, UsersStore) {
    var vm = this;

    vm.me = params.me;
    vm.nowDate = TimeService.getNowInStoreTime();
    vm.currentDate = TimeService.getBeginningOfDayFromDate(vm.nowDate).startOf('month');
    vm.workDayStartHour = Session.getWorkDayStartHour();

    vm.selectedDayOff = dayOff;
    vm.selectedDayOff._mif = TimeService.minimalIntervalTimeFormat(vm.selectedDayOff.range_twix);

    if (vm.selectedDayOff.metadata && vm.selectedDayOff.metadata['override_token_id']) {
      OverrideTokens.getById(vm.selectedDayOff.metadata['override_token_id'])
        .then(function(token) {
          vm.overrideToken = token;
          UsersStore.getRecordById(vm.overrideToken.granted_by)
            .then(function(user) {
              vm.overrideTokenGrantedBy = user;
            }, function(response) {
              console.log('Failed to fetch user who granted override token', response);
            });
        }, function(response) {
          console.log('Failed to fetch override token', response);
        });
    }


    vm.state = {
      workPeriodsReturned: false,
      statusInWords: calculateStatus(),
      dayOffWasModified: false,
      rawPermissions: null,
      derivedPermissions: null
    };

    var permissionsToLookUp = [
      'days_off.add_message',
      'days_off.add_message_to_mine',
      'days_off.cancel_my_request',
      'days_off.remove'
    ];

    function processRawPermissions() {
      var rawPerms = vm.state.rawPermissions;
      var myReq = vm.me.id === vm.selectedDayOff.user.id;

      vm.state.derivedPermissions = {
        canSendMessage: rawPerms['days_off.add_message'] || myReq && rawPerms['days_off.add_message_to_mine'],
        canRemove: rawPerms['days_off.remove'],
        canCancel: rawPerms['days_off.cancel_my_request']
      };

      setMessagePlaceholder();
    }

    UserPermissionsService.getCanDict(permissionsToLookUp, vm.selectedDayOff.organization_id)
      .then(function(dikt) {
        vm.state.rawPermissions = dikt;

        processRawPermissions();
      });

    function calculateStatus() {
      if (vm.selectedDayOff.$isApproved()) {
        return 'APPROVED';
      } else if (vm.selectedDayOff.$isDisapproved()) {
        return 'DISAPPROVED';
      } else if (vm.selectedDayOff.$isPending()) {
        return 'PENDING';
      } else if (vm.selectedDayOff.$isExpired()) {
        return 'EXPIRED';
      } else if (vm.selectedDayOff.$isCancelled()) {
        return 'CANCELLED';
      } else if (vm.selectedDayOff.$wasRemoved()) {
        return 'REMOVED';
      }
    }

    vm.close = function() {
      if (vm.state.dayOffWasModified) {
        $uibModalInstance.close(vm.selectedDayOff);
      } else {
        $uibModalInstance.dismiss();
      }
    };

    vm.commForm = {
      message: ''
    };


    vm.messagePlaceholderText = '';

    function setMessagePlaceholder() {
      if (vm.selectedDayOff && vm.me.id === vm.selectedDayOff.user.id) {
        vm.messagePlaceholderText = 'Reply to your day off request.';
      } else if (vm.state.derivedPermissions && vm.state.derivedPermissions.canSendMessage && vm.selectedDayOff && vm.me.id !== vm.selectedDayOff.user.id) {
        vm.messagePlaceholderText = 'Ask a question or provide explanation for your decision.';
      }
    }

    setMessagePlaceholder();
    vm.positionRelativeToLimitCache = {};


    function calcRequestPositionRelativeToLimit(weekIdx, dayIdx) {
      var dtTwix = $scope.dataByWeek[weekIdx].days[dayIdx].range_twix;

      DaysOffStore.getDaysOffIntersectingDate(dtTwix.start)
        .then(function(daysOff) {
          var filteredSortedDaysOff = _.sortBy(_.where(daysOff, function(dayOff) {
            return dayOff.$isPending() || dayOff.$isApproved();
          }), function(dayOff) {
            return dayOff._created_at_unix;
          });

          DayOffLimitStore.getLimitForDate(dtTwix.start)
            .then(function(limitRecord) {
              var matchingIdx = _.findIndex(filteredSortedDaysOff, {id: vm.selectedDayOff.id});
              var position;
              var cls = '';

              if (matchingIdx > -1) {
                // just in case we don't have a limit for this day, go ahead and set position and a class
                position = matchingIdx + 1;
                $scope.dataByWeek[weekIdx].days[dayIdx].limitPosition = position;
                cls = 'no-limit';


                // only do this if we have a limit for this day.
                if (!_.isNull(limitRecord)) {
                  $scope.dataByWeek[weekIdx].days[dayIdx].limitRecord = limitRecord;

                  if (position > limitRecord.limit) {
                    cls = 'over-limit';
                  } else if (position < limitRecord.limit) {
                    cls = 'under-limit';
                  } else if (position === limitRecord.limit) {
                    cls = 'at-limit';
                  }

                  vm.positionRelativeToLimitCache[weekIdx + '-' + dayIdx] = {
                    limitClass: cls,
                    limitPosition: position,
                    limitRecord: limitRecord
                  };
                } else {
                  console.log('did not find a match for', dtTwix.start.format());
                }

                if (cls !== '') {
                  $scope.dataByWeek[weekIdx].days[dayIdx]._cssClasses[cls] = true;
                }
              }

            }, function() {
              console.log('limit issue');
            });

        }, function() {
          console.log('issue pulling daysOff');
        });

    }



    function setupWeekCalendar() {
      var currentDate = moment(vm.selectedDayOff.range_twix.start);
      var firstWeek = TimeService.getWeekTwixFromMoment(moment(currentDate).startOf('week'));
      var startOfMonth = moment((TimeService.getWeekTwixFromMoment(moment(currentDate).startOf('month'))).end).startOf('month');

      $scope.weeks = _.map([0,1,2,3,4], function(x) {
        return (moment(firstWeek.start).add(x, 'weeks')).twix(moment(firstWeek.start).add(x+1, 'weeks'));
      });

      $scope.datesByWeek = _.map($scope.weeks, function(week) {
        return _.map(_.range(7), function(dayNum) {
          return moment(week.start).add(dayNum, 'days').twix(moment(week.start).add(dayNum + 1, 'days'));
        });
      });

      var isMultiDayRequest = vm.selectedDayOff.range_twix.start.dayOfYear() !== vm.selectedDayOff.range_twix.end.dayOfYear();
      var relativePositionLimitAnalysisToExec = [];

      var dayStartHour = Session.getWorkDayStartHour();

      $scope.dataByWeek = _.map($scope.datesByWeek, function (weekOfDays, weekIdx) {
        return {
          week: $scope.weeks[weekIdx],
          days: _.map(weekOfDays, function (dt, dayIdx) {
            // return ._cssClasses;
            // need to know what is previous or next month
            // need to know if this day is affected by the request

            var dtIntersection = dt.overlaps(vm.selectedDayOff.range_twix) ? Math.abs(vm.selectedDayOff.range_twix.intersection(dt).length('minutes')) : 0;

            var temp = {
              range_twix: dt,
              _cssClasses: {
                previous_month: dt.start.isBefore(startOfMonth),
                next_month: dt.start.isAfter(moment(startOfMonth).endOf('month')),
                request_overlaps_day: (!isMultiDayRequest && dtIntersection > 0) || (isMultiDayRequest && dtIntersection > ( dayStartHour * 60)), // if this is a single day request OR if the request overlaps the day by MORE than dayStartHour hrs, then show it.
                complete_overlap: dt.overlaps(vm.selectedDayOff.range_twix) &&
                (vm.selectedDayOff.range_twix.start.isBefore(dt.start) || vm.selectedDayOff.range_twix.start.isSame(dt.start)) &&
                (vm.selectedDayOff.range_twix.end.isAfter(dt.end) || vm.selectedDayOff.range_twix.end.isSame(dt.end))
              }
            };

            if ((vm.selectedDayOff.$isApproved() || vm.selectedDayOff.$isPending()) && (temp._cssClasses.request_overlaps_day || temp._cssClasses.complete_overlap)) {
              // pull up the limit on that day AND all DaysOff records on that day to calculate where this request is on each day
              relativePositionLimitAnalysisToExec.push([weekIdx, dayIdx]);
            }

            return temp;
          })
        };
      });

      _.each(relativePositionLimitAnalysisToExec, function(x) {
        calcRequestPositionRelativeToLimit(x[0], x[1]);
      });
    }

    setupWeekCalendar();


    vm.cancelDayOffRequest = function() {
      vm.selectedDayOff.$makeInactive()
        .then(function() {
          vm.state.dayOffWasModified = true;
          toastr.success('Your ' +  vm.selectedDayOff.$minimalIntervalTimeFormat() + ' was cancelled!', 'Success');
          DaysOffStore.addOrReplaceRecord(vm.selectedDayOff);
          DaysOffManagementModalService.setSelectedDayOffId(vm.selectedDayOff.id);
          vm.state.statusInWords = calculateStatus();
        }, function(response) {
          console.log('removeBlackoutDate had an error');
          console.log(response);
          SAErrorHandler.processError(response);
        })
    };

    vm.removeDayOffRequest = function() {
      vm.selectedDayOff.$remove()
        .then(function() {
          vm.state.dayOffWasModified = true;
          toastr.success(vm.selectedDayOff.$minimalIntervalTimeFormat() + ' request removed!', 'Success');
          DaysOffStore.addOrReplaceRecord(vm.selectedDayOff);
          DaysOffManagementModalService.setSelectedDayOffId(vm.selectedDayOff.id);
          vm.state.statusInWords = calculateStatus();
        }, function(response) {
          console.log('removeBlackoutDate had an error');
          console.log(response);
          SAErrorHandler.processError(response);
        })
    };

    vm.sendMessage = function() {
      if (vm.state.derivedPermissions.canSendMessage) {
        vm.selectedDayOff.$sendMessage(vm.commForm.message, vm.me)
          .then(function() {
            vm.state.dayOffWasModified = true;
            vm.commForm.message = '';
            toastr.success('Message sent for day off request!', 'Success');
          }, function(response) {
            console.log('sendMessage had an error');
            console.log(response);
            SAErrorHandler.processError(response);
          });
      }
    };


    // see if there are any overlapping work periods!
    WorkPeriods.getByUserId(vm.selectedDayOff.user.id, {
      start_time: moment(vm.selectedDayOff.range_twix.start).subtract(1, 'days').format('YYYY-MM-DD'),
      end_time: moment(vm.selectedDayOff.range_twix.end).add(1, 'days').format('YYYY-MM-DD')
    })
      .then(function(workPeriods) {
        vm.overlappingWorkPeriods = _.where(workPeriods, function(wp) {
          return wp.range_twix.overlaps(vm.selectedDayOff.range_twix) && Math.abs(wp.range_twix.intersection(vm.selectedDayOff.range_twix).length('minutes')) > 0;
        });
      }, function() {

      });
  });
